<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        class="reservationModal"
        :title="`${$locale.question}の回答`"
        hide-header
        hide-footer
        @hidden="close">
        <div v-if="isLoadedState">
            <div class="mb-3 font-weight-bold">引き続き、以下の質問にお答えください。</div>

            <div class="card mb-3">
                <div class="card-header">{{ $locale.question }}の回答</div>
                <div class="card-body">
                    <template v-if="doctorMenu === null">
                        <div v-for="( q, idx ) in matchingQuestions">
                            <label :class="{ 'is-required-ja' : q.flg_required === 1 }">{{ q.title }}</label>

                            <div class="mb-3">
                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <input
                                        v-model="q.content"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'matching_questions', idx ) || q.content && q.content.length > 255 }"
                                        :id="`q-matching-${q.id}`">
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <textarea
                                        v-model="q.content"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'matching_questions', idx ) || q.content && q.content.length > 500 }"
                                        :id="`q-matching-${q.id}`">
                                    </textarea>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.radio">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-matching-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-matching-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-matching-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-matching-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.check">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-matching-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-matching-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-matching-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-matching-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <div
                                    v-if="!hasLengthValidateMessage( 'matching_questions', idx )"
                                    class="invalid-feedback d-block mt-1">
                                    {{ validateMessage( 'matching_questions', idx ) }}
                                </div>

                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 255 }">
                                        <div>255文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/255</div>
                                    </div>
                                </template>
                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 500 }">
                                        <div>500文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/500</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="( q, idx ) in prefixCommonQuestions">
                            <label :class="{ 'is-required-ja' : q.flg_required === 1 }">{{ q.title }}</label>

                            <div class="mb-3">
                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <input
                                        v-model="q.content"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'prefix_common_questions', idx ) || q.content && q.content.length > 255 }"
                                        :id="`q-common-${q.id}`">
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <textarea
                                        v-model="q.content"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'prefix_common_questions', idx ) || q.content && q.content.length > 500 }"
                                        :id="`q-common-${q.id}`">
                                    </textarea>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.radio">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.check">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <div
                                    v-if="!hasLengthValidateMessage( 'prefix_common_questions', idx )"
                                    class="invalid-feedback d-block mt-1">
                                    {{ validateMessage( 'prefix_common_questions', idx ) }}
                                </div>

                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 255 }">
                                        <div>255文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/255</div>
                                    </div>
                                </template>
                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 500 }">
                                        <div>500文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/500</div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div v-for="( q, idx ) in questions">
                            <label :class="{ 'is-required-ja' : q.flg_required === 1 }">{{ q.title }}</label>

                            <div class="mb-3">
                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <input
                                        v-model="q.content"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'questions', idx ) || q.content && q.content.length > 255 }"
                                        :id="`q-${q.id}`">
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <textarea
                                        v-model="q.content"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'questions', idx ) || q.content && q.content.length > 500 }"
                                        :id="`q-${q.id}`">
                                    </textarea>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.radio">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.check">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <div
                                    v-if="!hasLengthValidateMessage( 'questions', idx )"
                                    class="invalid-feedback d-block mt-1">
                                    {{ validateMessage( 'questions', idx ) }}
                                </div>

                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 255 }">
                                        <div>255文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/255</div>
                                    </div>
                                </template>
                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 500 }">
                                        <div>500文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/500</div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div v-for="( q, idx ) in suffixCommonQuestions">
                            <label :class="{ 'is-required-ja' : q.flg_required === 1 }">{{ q.title }}</label>

                            <div class="mb-3">
                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <input
                                        v-model="q.content"
                                        type="text"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'suffix_common_questions', idx ) || q.content && q.content.length > 255 }"
                                        :id="`q-common-${q.id}`">
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <textarea
                                        v-model="q.content"
                                        class="form-control"
                                        :class="{ 'is-invalid' : detectError( 'suffix_common_questions', idx ) || q.content && q.content.length > 500 }"
                                        :id="`q-common-${q.id}`">
                                    </textarea>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.radio">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="radio"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.check">
                                    <div v-for="item in q.items" class="form-check">
                                        <input
                                            v-model="q.content"
                                            :value="item.title"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-${item.id}`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-${item.id}`">
                                            {{ item.title }}
                                        </label>
                                    </div>

                                    <div v-if="Number( q.flg_other ) === 1" class="form-check">
                                        <input
                                            v-model="q.content"
                                            value="その他"
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`q-common-${q.id}-item-other`">
                                        <label
                                            class="form-check-label"
                                            :for="`q-common-${q.id}-item-other`">
                                            その他
                                        </label>
                                    </div>
                                </template>

                                <div
                                    v-if="!hasLengthValidateMessage( 'suffix_common_questions', idx )"
                                    class="invalid-feedback d-block mt-1">
                                    {{ validateMessage( 'suffix_common_questions', idx ) }}
                                </div>

                                <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 255 }">
                                        <div>255文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/255</div>
                                    </div>
                                </template>
                                <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                                    <div
                                        class="d-flex justify-content-between text-muted small mt-1"
                                        :class="{ 'is-invalid-color' : q.content && q.content.length > 500 }">
                                        <div>500文字以内で回答してください</div>
                                        <div>{{ q.content !== null ? q.content.length : 0 }}/500</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div
                v-if="errors.message"
                class="invalid-feedback d-block text-center mt-1 mb-3">
                {{ errors.message[0] }}
            </div>

            <b-button
                class="nextButton"
                :disabled="inProgress"
                @click="handleOk">
                次へ進む
            </b-button>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'
    import {mapMutations} from "vuex";

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                questionTypes: constants.interview_question_types,
                modalShow: false,
                mode: null,
                user: null,
                doctor: null,
                doctorMenu: null,
                schedule: null,
                medicalCourse: null,
                prevConsultation: null,
                matchingQuestions: null,
                commonQuestions: null,
                questions: null,
                errors: {},
                failed: false,
            }
        },

        computed: {
            isLoadedState: function () {
                if (this.mode === 'default' || this.mode === 'auto') {
                    return this.user !== null
                        && this.doctor !== null
                        && this.doctorMenu !== null
                        && this.medicalCourse !== null
                        && this.schedule !== null
                        && this.paymentMethod !== null
                }
                else if (this.mode === 'matching') {
                    return this.user !== null
                        && this.medicalCourse !== null
                        && this.schedule !== null
                        && this.paymentMethod !== null
                }
            },

            /**
             * デフォルト問診のリスト（先頭表示）
             *
             * @return array
             */
            prefixCommonQuestions: function () {
                if (!this.commonQuestions) return []
                return this.commonQuestions.filter((question) => question.display_type === 'prefix')
            },

            /**
             * デフォルト問診のリスト（末尾表示）
             *
             * @return array
             */
            suffixCommonQuestions: function () {
                if (!this.commonQuestions) return []
                return this.commonQuestions.filter((question) => question.display_type === 'suffix')
            },
        },

        created: function() {
            bus.$on('open-modal-reservation-interview', this.open)
            bus.$on('close-modal-reservation-interview', this.close)
            bus.$on('clear-reservation-interview-questions', this.clearQuestions)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-reservation-interview')
            bus.$off('close-modal-reservation-interview')
            bus.$off('clear-reservation-interview-questions')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: async function () {
                this.mode = this.$store.state.reservation.mode
                this.user = this.$store.state.reservation.user
                this.doctorMenu = this.$store.state.reservation.doctorMenu
                this.doctor = this.doctorMenu ? this.doctorMenu.doctor : null
                this.medicalCourse = this.$store.state.reservation.medicalCourse
                this.schedule = this.$store.state.reservation.schedule
                this.prevConsultation = this.$store.state.reservation.prevConsultation
                this.paymentMethod = this.$store.state.reservation.paymentMethod
                this.userCoupon = this.$store.state.reservation.userCoupon

                // 問診未取得の場合
                if (this.matchingQuestions === null || this.commonQuestions === null || this.questions === null) {
                    await this.fetchInterviewQuestions()
                }

                // 過去の回答を取得
                if (this.prevConsultation) {
                    await this.fetchPrevInterviewAnswers()
                }

                const isSkip = this.doctorMenu
                    ? this.commonQuestions.length < 1 && this.questions.length < 1
                    : this.matchingQuestions.length < 1

                // 問診が1つも無ければスキップして予約内容確認モーダルへ進む
                if (isSkip) {
                    this.setMatchingQuestions([])
                    this.setCommonQuestions([])
                    this.setQuestions([])
                    bus.$emit('open-modal-reservation-confirm')
                    return
                }
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function() {
                // 回答内容を残しておく
                this.setMatchingQuestions(this.matchingQuestions)
                this.setCommonQuestions(this.commonQuestions)
                this.setQuestions(this.questions)

                this.modalShow = false
            },

            /**
             * 問診を未取得の状態にする
             *
             * メニューが変更された場合や予約が完了した際に実行する
             * それ以外のケース（日時選択モーダルに戻った場合など）では出来る限り回答内容を残しておきたいため実行しない
             */
            clearQuestions: function () {
                this.commonQuestions = null
                this.questions = null
                this.matchingQuestions = null
            },

            /**
             * 問診取得
             */
            fetchInterviewQuestions: async function () {
                const endpoint = constants.user.interview_questions.endpoint.base
                const endpointCommon = constants.user.interview_common_questions.endpoint.base
                const endpointMatching = constants.user.interview_matching_questions.endpoint.base

                if (!this.doctorMenu || (this.prevConsultation && this.prevConsultation.is_matching_reserved)) {
                    await axios.get(`${endpointMatching}?medical_course_id=${this.medicalCourse.id}`)
                        .then(({data}) => {
                            this.matchingQuestions = data.data
                        })
                    this.questions = []
                    this.commonQuestions = []
                }
                else {
                    await axios.get(`${endpoint}?doctor_id=${this.doctor.id}&doctor_menu_id=${this.doctorMenu.id}`)
                        .then(({data}) => {
                            this.questions = data.data
                        })
                    await axios.get(`${endpointCommon}?medical_course_id=${this.medicalCourse.id}`)
                        .then(({data}) => {
                            this.commonQuestions = data.data
                        })
                    this.matchingQuestions = []
                }
            },

            /**
             * 過去の回答を取得
             */
            fetchPrevInterviewAnswers: async function () {
                const endpoint = constants.user.consultations.endpoint.base

                await axios.get(`${endpoint}/${this.prevConsultation.id}/answers/draft`)
                    .then(({data}) => {
                        data.data.answers.forEach((answer) => {
                            const idx = this.questions.findIndex((q) => q.id === answer.interview_question_id)
                            if (idx > -1) {
                                this.questions[idx].content = Number(this.questions[idx].interview_question_type_id) === this.questionTypes.check
                                    ? answer.content.split(',')
                                    : answer.content
                            }
                        })
                        data.data.common_answers.forEach((answer) => {
                            const idx = this.commonQuestions.findIndex((q) => q.id === answer.interview_common_question_id)
                            if (idx > -1) {
                                this.commonQuestions[idx].content = Number(this.commonQuestions[idx].interview_question_type_id) === this.questionTypes.check
                                    ? answer.content.split(',')
                                    : answer.content
                            }
                        })
                        data.data.matching_answers.forEach((answer) => {
                            const idx = this.matchingQuestions.findIndex((q) => q.id === answer.interview_matching_question_id)
                            if (idx > -1) {
                                this.matchingQuestions[idx].content = Number(this.matchingQuestions[idx].interview_question_type_id) === this.questionTypes.check
                                    ? answer.content.split(',')
                                    : answer.content
                            }
                        })
                    })
            },

            /**
             * 問診エラーメッセージ表示
             */
            detectError: function ( attribute, idx ) {
                const self = this;

                const filtered = Object.keys( self.errors )
                    .filter( key => key === `${attribute}.${idx}` );

                return filtered.length > 0
            },

            /**
             * 問診エラーメッセージ表示
             */
            validateMessage: function (attribute, idx) {
                const filtered = Object.keys(this.errors)
                    .filter(key => key === `${attribute}.${idx}`)
                    .map(key => this.errors[key][0])

                return filtered ? filtered[0] : null
            },

            /**
             * 文字数制限のエラーメッセージ判定
             */
            hasLengthValidateMessage: function (attribute, idx) {
                const result = this.validateMessage(attribute, idx)
                if (!result) return false

                return result.includes('255') || result.includes('500')
            },

            /**
             * 「次へ進む」ボタン押下時
             *
             * @param {object} e
             */
            handleOk: async function(e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    medical_course_id: this.medicalCourse.id,
                    doctor_id: this.doctor ? this.doctor.id : null,
                    doctor_menu_id: this.doctorMenu ? this.doctorMenu.id : null,
                    start_time: this.startDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    end_time: this.endDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    questions: this.questions,
                    prefix_common_questions: this.prefixCommonQuestions,
                    suffix_common_questions: this.suffixCommonQuestions,
                    matching_questions: this.matchingQuestions,
                    confirm: 1,
                }

                await axios.post(constants.user.consultations.endpoint.base, params)
                    .then(({data}) => {
                        this.errors = {}
                        if (data.status === 'OK') {
                            this.pushAnalyticsDataLayer()
                            this.setMatchingQuestions(this.matchingQuestions)
                            this.setCommonQuestions(this.commonQuestions)
                            this.setQuestions(this.questions)
                            bus.$emit('open-modal-reservation-confirm')
                        }
                    })
                    .catch( ({response}) => {
                        this.errors = response.data.errors
                        bus.$emit('alert-danger')
                    })

                this.inProgress = false
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             */
            pushAnalyticsDataLayer: function () {
                if (this.$locale.type !== 'consul') return

                const doctorMenuId = this.doctorMenu ? this.doctorMenu.id : null
                const doctorMenuTitle = this.doctorMenu ? this.doctorMenu.title : null

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__inputInterviews',
                    doctorMenuId: doctorMenuId,
                    //doctorMenuTitle: this.isAutoReserved ? 'おすすめ相談' : doctorMenuTitle,
                    doctorMenuTitle: doctorMenuTitle,
                })
            },

            /**
             * 相談開始日時フォーマット
             *
             * @return {moment}
             */
            startDateTime: function () {
                if (this.schedule.start_time === '24:00') {
                    this.schedule.start_time = '00:00'
                }
                const format = this.schedule.date.format('YYYY-MM-DD')
                return this.helper.jstTime(`${format} ${this.schedule.start_time}:00`, this.user.timezone)
            },

            /**
             * 相談終了日時フォーマット
             *
             * @return {moment}
             */
            endDateTime: function () {
                if (this.mode === 'default') {
                    return this.startDateTime().add(this.doctorMenu.consultation_minutes, 'minutes')
                }
                return this.startDateTime().add(this.medicalCourse.matching_minutes, 'minutes')
            },

            ...mapMutations({
                setQuestions: 'reservation/setQuestions',
                setCommonQuestions: 'reservation/setCommonQuestions',
                setMatchingQuestions: 'reservation/setMatchingQuestions',
            }),
        },
    }
</script>

<style lang="scss" scoped>
    .reservationModal {
        .table {
            th, td {
                font-size: .8rem;
            }
        }
    }

    .vc-timezone-box {
        display: inline-block;
        padding: 4px 6px;
        font-size: 13px;
        background-color: rgb(230, 230, 230);
        border-radius: 3px;
    }

    .nextButton {
        display: block;
        width: 210px;
        height: 42px;
        line-height: 42px;
        padding: 0;
        margin: 0 auto;
        color: #fff;
        font-weight: bold;
        text-align: center;
        background-color: #CF798A;
        border: none;
        border-radius: 8px;
        cursor: pointer;
    }
</style>
